<template>
  <div class="distributionBoxStyle">
    <!--搜索框区域-->
    <div :class="whether ? 'isFixed' : ''" style="width: 100%">
      <div class="searchBox item">
        <form action="/" @submit.prevent>
          <van-search clearable placeholder="请输入想要搜索的内容" show-action
                      class="searchCommodity" v-model="content" :left-icon="imgUrl" @search="searchProject">
            <template #action>
            </template>
          </van-search>
        </form>
      </div>
      <div class="filter-div">
        <filterData ref="filter"
                    :cityName="cityName"
                    :showPubDay="true" :showCity="true" :showGongZhong="true"
                    :pubDayIds="pubDayIds" :activePubDay="activePubDay"
                    :cityIds="cityIds" :activeCity="activeCity"
                    :gongZhongIds="gongZhongIds" :activeGongZhong="activeGongZhong"
        >
        </filterData>
      </div>
    </div>

    <div :class="whether ? 'isFixedList' : ''">
      <div v-if="!refreshing && isSearch" class="totalRows" style="text-align: center">您搜索出了 <a>{{ totalRows }}</a>
        条找活信息
      </div>

      <div v-if="list.length === 0 && !incomeListLoading" class="noContent">
        <img src="../../assets/images/blank_icon_zhaogong.png">
        <div class="blank-tip">暂无找活信息</div>
      </div>
      <template v-else>
        <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
          <van-list
            class="list list-content"
            v-model="incomeListLoading"
            :finished="listLoadFinished"
            @load="getAssignTaskList"
          >
            <projectList :list="list"/>
          </van-list>
        </van-pull-refresh>
      </template>
    </div>

    <div class="publish">
      <img src="../../assets/images/publicImg/btn_zhaogong.png" class="btn_fabu" @click="publishDistribution">
    </div>

  </div>
</template>

<script>
import { isAuth } from '@api/home'
import projectList from '@/components/projectList'
import filterData from '@/components/filter'
import { assignTaskList } from '@api/distribution'
import imgUrl from '../../assets/images/icon_search.png'
import filterImg from '../../assets/images/publicImg/shaixuan.png'

export default {
  name: 'index',
  components: {
    projectList,
    filterData
  },
  data () {
    return {
      cityName: undefined,
      whether: false,
      totalRows: 0,
      list: [],
      imgUrl: imgUrl,
      filterImg: filterImg,
      pageSize: 10,
      pageNum: 0,
      content: '',
      incomeListLoading: false,
      listLoadFinished: false,
      initParams: {},

      // 发布时间
      pubDayIds: [],
      activePubDay: [],

      // 地区
      cityIds: [],
      activeCity: [],

      // 工种
      gongZhongIds: [],
      activeGongZhong: [],

      isSearch: false,  // 是否搜索，展示搜索条数
      refreshing: false
    }
  },
  created () {

    this.defaultCityId = this.$route.query.cityId
    this.cityId = this.$route.query.cityId
    this.cityName = this.$route.query.cityName
    if (this.$route.query.cityId) {
      this.cityIds.push(this.cityId)
      this.activeCity = [{
        id: this.cityId,
        text: this.cityName
      }]
    }

    this.getAssignTaskList()
  },

  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },

  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {

    handleScroll () {
      //计算滚动条位置
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      //计算绑定div位置
      var offsetTop = document.querySelector('.distributionBoxStyle').offsetTop
      //进行比较设置位置fixed
      this.whether = scrollTop > offsetTop
    },

    // 搜索
    searchProject () {
      this.pageNum = 0
      this.list = []
      this.getAssignTaskList()
    },

    // 下拉刷新
    onRefresh () {
      this.listLoadFinished = true
      this.refreshing = true
      this.pageNum = 0
      this.getAssignTaskList()
    },

    // 获取列表信息
    getAssignTaskList () {
      this.pageNum++
      this.incomeListLoading = true
      // 市id
      let citiesIds = []
      if (this.activeCity) {
        for (let i = 0; i < this.activeCity.length; i++) {
          citiesIds.push(this.activeCity[i].id)
        }
      }

      // 发布时间id
      let pubDay = ''
      if (this.pubDayIds) {
        pubDay = this.pubDayIds.toString()
        if (pubDay === '0') {
          pubDay = ''
        }
      }

      // 工种id
      let typeWorks = ''
      if (this.gongZhongIds) {
        typeWorks = this.gongZhongIds.toString()
        if (typeWorks === '0') {
          typeWorks = ''
        }
      }

      var params = {
        pubDay: pubDay,
        cityCode: citiesIds.toString(),
        typeWorks: typeWorks,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        content: this.content
      }

      assignTaskList(params).then(res => {
        if (res.data.code === 200) {
          if (this.refreshing) {
            this.list = []
            this.listLoadFinished = false
          }
          this.totalRows = res.data.data.totalRows
          this.incomeListLoading = false
          if (res.data.data.rows && res.data.data.rows.length === 0) {
            this.listLoadFinished = true
          } else {
            this.list = this.list.concat(res.data.data.rows)
          }

          this.refreshing = false

          // 是否搜索
          this.isSearch = (this.cityIds.length === 1 && this.cityIds.indexOf(this.defaultCityId) === -1) || this.content || (this.pubDayIds.length > 0) || (this.cityIds.length > 1) || (this.gongZhongIds.length > 0)
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 触发筛选（公共筛选组件所用到）
    filter (queryParams) {
      // 发布时间
      if (queryParams.pubDayIds) {
        this.pubDayIds = queryParams.pubDayIds
      }
      if (queryParams.activePubDay) {
        this.activePubDay = queryParams.activePubDay
      }

      // 地区
      if (queryParams.cityIds) {
        this.cityIds = queryParams.cityIds
      }
      if (queryParams.activeCity) {
        this.activeCity = queryParams.activeCity
      }

      // 工种
      if (queryParams.gongZhongIds) {
        this.gongZhongIds = queryParams.gongZhongIds
      }
      if (queryParams.activeGongZhong) {
        this.activeGongZhong = queryParams.activeGongZhong
      }
      // 滚动到顶部（关闭筛选弹窗后可能不会回到顶部）
      window.scrollTo({
        'top': 0,
        'behavior': 'smooth'
      })
      this.pageNum = 0
      this.list = []
      this.getAssignTaskList()

    },

    // 搜索
    search () {
      // 滚动到顶部（关闭筛选弹窗后可能不会回到顶部）
      window.scrollTo({
        'top': 0,
        'behavior': 'smooth'
      })
      this.pageNum = 0
      this.list = []
      this.getAssignTaskList()
    },

    // 跳转发布招工广告
    publishDistribution () {
      if (!localStorage.getItem('token')) {
        // 登录页面
        this.$bridge.callHandler('jumpLogin', { isExpired: 0 }, response => {
          console.log('response:', response)
        })
      } else {
        isAuth().then(res => {
          if (res.data.code === 200) {
            const data = {
              url: `${process.env.VUE_APP_BASE_HOST}/invitationBids/publishPage`,
              title: '招工信息'
            }
            this.$bridge.callHandler('newPage', data, response => {
              console.log('response:', response)
            })
            // this.enterRouter('publishPage')
          } else {
            this.$toastMsg(123456)
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/mixin";

.van-list {
  min-height: 70vh;
}

.distributionBoxStyle {
  padding-bottom: 120px;
  /*设置搜索图标*/
  //noinspection CssInvalidPseudoSelector
  ::v-deep .van-field__left-icon {
    display: block !important;
  }

  //noinspection CssInvalidPseudoSelector
  ::v-deep .van-search__content {
    padding-left: 10px;
  }

  //noinspection CssInvalidPseudoSelector
  ::v-deep .van-cell {
    display: flex;
  }

  //noinspection CssInvalidPseudoSelector
  ::v-deep .bottomBox {
    .van-icon__image {
      width: 22px;
      height: 22px;
      object-fit: contain;
    }
  }

  .van-sticky--fixed {
    .search {
      left: 27px;
      top: 25px;
    }

    .searchBigBox {
      padding: 15px;
    }
  }

  .projectBox {
    background-color: #fff;
    color: #333;
    padding: 12px;
    border-radius: 5px;
    margin-bottom: 15px;
    box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.04);

    .name {
      font-weight: bold;
      @include add_size($font_size_18);
      color: #393939;
      margin-bottom: 12px;
    }

    .descriptionBox {
      display: flex;
    }

    .bottomBox {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .icon_location {
        width: 16px;
        height: 16px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 4px;
      }

      span {
        @include add_size($font_size_13);
        color: #666;
      }
    }


    .description {
      @include add_size($font_size_16);
      color: #666;
      height: 66px;
    }
  }

  .searchCommodity {
    top: 0;
    width: 100%;
    padding: 8px 10px;
    z-index: 99;
    background: #fff;

    .van-field__control {
      font-size: 15px;
    }
  }


  .van-search__action {
    padding: 0;
  }

  .searchCommodity .van-search__content {
    background: #F8F8F8;
  }

  .van-button--primary {
    background-color: #108791;
    border: 0.02667rem solid #108791;
  }

  .btn-filter {
    width: 103px;
    height: 65px;
  }

  .totalRows {
    @include add_size($font_size_14);
    padding: 10px 10px 0px 10px;
  }
}
</style>
